import tippy from "tippy.js"
import "tippy.js/dist/tippy.css"
import "tippy.js/themes/translucent.css"

import elementMatches from "./elementMatches"
import tooltipOptions, {tooltipSelector} from "./tooltipOptions"

const selector = "[data-clipboard-copy]"
const tooltipTriggerEvent = new MouseEvent("mouseenter", {
  bubbles: true,
  cancelable: true,
  view: window
})

const actionTooltipDuration = 1500
const actionTooltipSelector = "[data-action-tooltip]"

let actionTooltip
let allTooltips

document.addEventListener("DOMContentLoaded", (e) => {
  tippy(actionTooltipSelector, {
    ...tooltipOptions,
    content: "", // content is set dynamically
    trigger: "manual",
    duration: [0, 300],
    onTrigger: () => {}, // ignore default auto-close feature
    onShown: (instance) => {
      setTimeout(() => {
        instance.hide()
      }, actionTooltipDuration)
    },
    onHidden: (instance) => {
      // This check ensures that this instance is the last shown action tooltip.
      if (instance === actionTooltip) {
        actionTooltipHidden()
      }
    }
  })
})

document.addEventListener("click", (e) => {
  const element = elementMatches(e.target, selector)

  if (element) {
    e.preventDefault()
    e.stopPropagation()

    const copyText = element.dataset.clipboardCopy
    try {
      navigator.clipboard.writeText(copyText).then(() => {
        showActionTooltip(element, element.dataset.clipboardCopySuccess)
      })
    } catch {
      showActionTooltip(element, element.dataset.clipboardCopyFailure)
    }
  }
})

const triggerTooltipOnHover = () => {
  const tooltipElement = document.querySelector(`${tooltipSelector}:hover`)
  if (tooltipElement) {
    tooltipElement.dispatchEvent(tooltipTriggerEvent)
  }
}

const actionTooltipHidden = () => {
  allTooltips?.enable()
  // If a cursor hovers over a new element while tooltips where disabled
  // the tooltip will not show on that element. This function fixes that.
  triggerTooltipOnHover()
  allTooltips = null
  actionTooltip = null
}

const showActionTooltip = (element, content) => {
  // Existing tooltip/tippy instance is a part of a singleton so all its
  // options are grouped somehow. This is the reason why existing tooltip can't
  // be used to show new 'content' message.
  const existing = element._tippy
  // Other tooltips (singleton) is not defined on touch devices.
  allTooltips = existing?.singleton
  const existingActionTooltip = actionTooltip

  actionTooltip = element.querySelector(actionTooltipSelector)._tippy
  actionTooltip.setContent(content)
  actionTooltip.show()
  allTooltips?.disable() // don't show other tooltips

  // This is done last to prevent races in 'onHidden' callback.
  if (existingActionTooltip) {
    existingActionTooltip.hide()
  }
}
